import React, { useState, useEffect } from "react"
import axios from "axios"
import { BASE_URL } from "../../Util/requests"
import ButtonsCadastre from "../../Components/CadastreButtons"
import Footer from "../../Components/Footer"
import Header from "../../Components/Header"
import Input from "../../Components/Input"
import Menu from "../Menu"
import Select from "../../Components/Select"
import SearchServiceNational from "./Search"
import SearchServiceMunicipal from "../ServiceMunicipal/Search"
import Titulo from "../../Components/Titulo"
import image_loading from "../../Images/spinner.gif"

const ServiceNational = ({modeSearch, databaseType, databasePath, jsonCompany, jsonLogin, system, setReturn, height, width, logoff}) => {
  const [originCode, setOriginCode] = useState("")
  const [code, setCode] = useState("")
  const [description, setDescription] = useState("")
  const [standard, setStandard] = useState(2)

  const [jServiceNational, setJServiceNational] = useState({})

  const [showMenu, setShowMenu] = useState(true)
  const [showSearch, setShowSearch] = useState(true)

  const [loading, setLoading] = useState(null)
  const [warning, setWarning] = useState("")
  const [error, setError] = useState("")

  const [updateFocu, setUpdateFocu] = useState(0)

  useEffect(() => {
    if (originCode === "") {
      setDescription("")
      setStandard(2)
    }
    else
    {
      setDescription(jServiceNational.DESCRIPTION)
      setStandard(jServiceNational.DEFAULT)
    }

    if (originCode === "") document.getElementById("serviceNationalCode") && document.getElementById("serviceNationalCode").focus()
    else document.getElementById("serviceNationalDescription") && document.getElementById("serviceNationalDescription").focus()
  }, [originCode, jServiceNational, updateFocu])


  const add = () => {
    setLoading("")
    setWarning("")
    setError("")

    if (code === ""){
      setDescription("")
      setStandard(2)
    }
    else {
      setOriginCode("")
      setCode("")
    }

    setUpdateFocu(updateFocu + 1)
  }

  const returnAdd = () => {
    setWarning("")
    setError("")
    setCode("")
    setOriginCode("")

    setShowSearch(true)
  }

  const save = () => {
    let returnJson = []
    let jsonServiceNational_New = {}
        
    setWarning("")
    setError("")

    jsonServiceNational_New = "{"
    if (code !== "") jsonServiceNational_New += "\"CODE\": "+ code

    if (description !== "") {
      if (jsonServiceNational_New !== "{ ") jsonServiceNational_New += ", "
      jsonServiceNational_New += "\"DESCRIPTION\": \""+ description +"\""
    }

    if (jsonServiceNational_New !== "{ ") jsonServiceNational_New += ", "
    jsonServiceNational_New += "\"DEFAULT\": "+ standard

    jsonServiceNational_New += " }"

    if (originCode === ""){
      setLoading("Aguarde incluindo o registro...")
            
      const formData = new FormData()
      formData.append("DATABASE_TYPE", databaseType)
      formData.append("DATABASE_PATH", databasePath)
      formData.append("JSON_NEW_1", jsonServiceNational_New)
      formData.append("JSON_COMPANY", JSON.stringify(jsonCompany))
      formData.append("JSON_LOGIN", JSON.stringify(jsonLogin))
      formData.append("SYSTEM", system)

      axios.post(BASE_URL + "SERVICE_CODE_NATIONAL/Insert", formData)
      .then((response) => { returnJson = JSON.parse(response.data) })
      .catch((response) => { returnJson = JSON.parse("{ \"SUCCESS\": false, \"OBJECT\": null, \"AUDIT_CONFIGURATION\": null, \"WARNING\": null"+
        ", \"ERROR\": \"Não foi possível incluir o serviço nacional. ("+ response +")\"}") })
      .finally(() => {
        if (returnJson.SUCCESS === false){
          setError(returnJson.ERROR)
          setLoading("")
          document.getElementById("serviceNationalDescription") && document.getElementById("serviceNationalDescription").focus()
          return
        }

        returnJson.WARNING ? setWarning("Inclusão efetuada com sucesso! ("+ returnJson.WARNING +")")
        : setWarning("Inclusão efetuada com sucesso!")

        setJServiceNational(returnJson.OBJECT)  

        setOriginCode(returnJson.OBJECT.CODE)
        setCode(returnJson.OBJECT.CODE)
        setLoading("")
        setUpdateFocu(updateFocu + 1)
      })
    }
    else
    {
      setLoading("Aguarde alterando o registro...")

      const formData = new FormData()
      formData.append("DATABASE_TYPE", databaseType)
      formData.append("DATABASE_PATH", databasePath)
      formData.append("JSON_OLD", JSON.stringify(jServiceNational))
      formData.append("JSON_NEW_1", jsonServiceNational_New)
      formData.append("JSON_COMPANY", JSON.stringify(jsonCompany))
      formData.append("JSON_LOGIN", JSON.stringify(jsonLogin))
      formData.append("SYSTEM", system)

      axios.put(BASE_URL + "SERVICE_CODE_NATIONAL/Update", formData)
      .then((response) => { returnJson = JSON.parse(response.data) })
      .catch((response) => { returnJson = JSON.parse("{ \"SUCCESS\": false, \"OBJECT\": null, \"AUDIT_CONFIGURATION\": null, \"WARNING\": null"+
        ", \"ERROR\": \"Não foi possível alterar o serviço nacional. ("+ response +")\"}") })
      .finally(() => {
        if (returnJson.SUCCESS === false){
          setError(returnJson.ERROR)
          setLoading("")
          document.getElementById("serviceNationalDescription") && document.getElementById("serviceNationalDescription").focus()
          return
        }

        returnJson.WARNING ? setWarning("Alteração efetuada com sucesso! ("+ returnJson.WARNING +")")
        : setWarning("Alteração efetuada com sucesso!")

        setJServiceNational(returnJson.OBJECT)
        setLoading("")
        setUpdateFocu(updateFocu + 1)
      })
    }
  }    

  const setAdd = () => {
    setShowSearch(false)
    add()

    setUpdateFocu(updateFocu + 1)
  }

  const setFieldSelected = () => {
  }

  const setSelected = (event) => {
    setShowSearch(false)
    setJServiceNational(event)
    setCode(event.CODE)
    setOriginCode(event.CODE)
  }

  return(
    <div style={{display: "flex", flexDirection: "column", flexGrow: 1, minHeight: height}}>
      <div style={(width < 690) ? {display: "flex", flexGrow: 1, flexDirection: "column", marginBottom: 10}
        : {display: "flex", flexGrow: 1, flexDirection: "row", marginBottom: 10}}>

        { showMenu &&
          <div style={{display: "flex", flexGrow: 0}}>
            <Menu jsonCompany={jsonCompany} jsonLogin={jsonLogin} showMenu={showMenu} setShowMenu={setShowMenu} height={height} width={width}
              logoff={logoff} />
          </div>
        }

        <div style={{display: "flex", flexGrow: 1, flexDirection: "column"}}>
          <Header
            title="Serviço Nacional"
            titleSearch="Pesquisa dos serviços nacionais"
            showSearch={showSearch}
            showMenu={showMenu}
            setShowMenu={setShowMenu}
            width={width} />

          { showSearch ?
              <SearchServiceNational
                modeSearch={modeSearch}
                databaseType={databaseType}
                databasePath={databasePath}
                jsonLogin={jsonLogin}
                jsonCompany={jsonCompany}
                system={system}
                setAdd={setAdd}
                setSelected={setSelected}
                setReturn={setReturn} 
                showMenu={showMenu}
                width={width} />
            :
              <>
                { loading ?
                    <div style={{display: "flex", flexDirection: "column", flexGrow: 1, justifyContent: "center", alignItems: "center"}}>
                      <img style={{marginBottom: 10, height: 32, width: 32}} src={image_loading} alt="Carregando"/>
                      <label style={{fontWeight: 600, color: "rgb(0, 177, 171)"}}>{loading}</label>
                    </div>
                  :
                    <>
                      <ButtonsCadastre save={() => save()} add={() => add()} returnAdd={() => returnAdd()} />

                      <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <div style={{backgroundColor: "rgb(0, 177, 171)", marginTop: 8, height: 10, width: "98%"}} />
                      </div>
                    
                      <div style={(width < 450) ? {paddingLeft: 10, paddingRight: 10} : {paddingLeft: 20, paddingRight: 20}}>
                        <div style={{display: "flex", flexGrow: 0, flexDirection: "row", paddingTop: 0, paddingRight: 10, paddingBottom: 0,
                          paddingLeft: 10}}>
                          { warning && 
                            <div style={{display: "flex", flexGrow: 1, flexDirection: "row", justifyContent: "center", marginTop: 10,
                              marginBottom: 10}}>
                              <label style={{fontWeight: 600, color: "rgb(0, 177, 171)"}}>{warning}</label>
                            </div> 
                          }

                          { error &&
                            <div style={{display: "flex", flexGrow: 1, flexDirection: "row", justifyContent: "center", marginTop: 10,
                              marginBottom: 10}}>
                              <label style={{fontWeight: 600, color: "red"}}>{error}</label>
                            </div>
                          }
                        </div>

                        <div style={(showMenu) ?
                            (width < 1090) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginTop: 10}
                            : {display: "flex", flexDirection: "row", flexGrow: 0, marginTop: 10}
                          :
                            (width < 790) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginTop: 10}
                            : {display: "flex", flexDirection: "row", flexGrow: 0, marginTop: 10}}>
                          <div style={(showMenu) ? 
                              (width < 590) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                              : (width < 690) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                              : (width < 890) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                              : {display: "flex", flexDirection: "row", flexGrow: 1}
                            :
                              (width < 590) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                              : {display: "flex", flexDirection: "row", flexGrow: 1}}>
                            <div style={(showMenu) ?
                                (width < 590) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                : (width < 690) ? {display: "flex", flexGrow: 0, minWidth: 160, maxWidth: 160}
                                : (width < 890) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                : {display: "flex", flexGrow: 0, minWidth: 160, maxWidth: 160}
                              :
                                (width < 590) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                : {display: "flex", flexGrow: 0, minWidth: 160, maxWidth: 160}}>
                              <Input
                                type="text"
                                name="serviceNationalCode"
                                description="Código"
                                value={code}
                                maxLength={6}
                                disabled={(originCode === "") ? false : true}
                                require={true}
                                image={false}
                                typeInput={2}
                                onSelect={setFieldSelected}
                                onChange={(event) => setCode(event.target.value)} />
                            </div>
                            <div style={(showMenu) ? 
                                (width < 590) ? {display: "flex", flexGrow: 1, minWidth: 180, marginTop: 10}
                                : (width < 690) ? {display: "flex", flexGrow: 1, minWidth: 180, marginLeft: 10}
                                : (width < 890) ? {display: "flex", flexGrow: 1, minWidth: 180, marginTop: 10}
                                : {display: "flex", flexGrow: 1, minWidth: 180, marginLeft: 10}
                              : 
                                (width < 590) ? {display: "flex", flexGrow: 1, minWidth: 180, marginTop: 10}
                                : {display: "flex", flexGrow: 1, minWidth: 180, marginLeft: 10}}>
                              <Input
                                type="text"
                                name="serviceNationalDescription"
                                description="Descrição"
                                value={description}
                                maxLength={255}
                                disabled={false}
                                require={true}
                                image={false}
                                typeInput={2}
                                onSelect={setFieldSelected}
                                onChange={(event) => setDescription(event.target.value)} />
                            </div>
                          </div>
                          <div style={(showMenu) ?
                              (width < 1090) ? {display: "flex", flexGrow: 1, minWidth: 180, marginTop: 10}
                              : {display: "flex", flexGrow: 0, minWidth: 180, marginLeft: 10}
                            :
                              (width < 790) ? {display: "flex", flexGrow: 1, minWidth: 180, marginTop: 10}
                              : {display: "flex", flexGrow: 0, minWidth: 180, marginLeft: 10}}>
                            <Select
                              name="serviceNationalStandard"
                              description="Padrão"
                              value={standard || 2}
                              require={true}
                              options={JSON.parse("{ \"RESULT\": [{\"ID\": 0, \"VALUE\": \"Selecione...\" }"+
                                ", {\"ID\": 1, \"VALUE\": \"Sim\" }, {\"ID\": 2, \"VALUE\": \"Não\" }] }")}
                              image={false}
                              typeInput={2}
                              onSelect={setFieldSelected}
                              set={setStandard} />
                          </div>
                        </div>

                        { originCode &&
                          <div style={{marginTop: 10}}>
                            <Titulo description="Serviço Municipal"/>
                            <SearchServiceMunicipal
                              databaseType={databaseType}
                              databasePath={databasePath}
                              jsonServiceNational={jServiceNational}
                              jsonCompany={jsonCompany}
                              jsonLogin={jsonLogin}
                              system={system} 
                              showMenu={showMenu}
                              width={width} />
                          </div>
                        }
                      </div>
                    </>
                }
              </>
          }
        </div>
      </div>

      <Footer/>
    </div>
  )
}

export default ServiceNational